import { type WorkingStatus } from '../model/working-status';

import { traderStatuses, workingStatuses } from '../constants';
import { type TraderStatus } from '../model';

export const formatTrader = {
    status: (status?: TraderStatus) => {
        if (!status) {
            return '';
        }

        const { label } =
            traderStatuses.find((p) => {
                return p.value === status;
            }) ?? {};

        return label;
    },
    workingStatus: (workingStatus?: WorkingStatus) => {
        if (!workingStatus) {
            return '';
        }

        const { label } =
            workingStatuses.find((p) => {
                return p.value === workingStatus;
            }) ?? {};

        return label;
    },
} as const;
